import type { FaireProductEntity } from "../../entity_types/product";

export const p_nzvud66ryn: FaireProductEntity = {
  token: "p_nzvud66ryn",
  type: "product",
  name: "OLAPLEX No. 5 Bond Maintenance Conditioner",
  brandToken: "b_54f7kuhpda",
  brandName: "Dermstreet",
  imageUrl:
    "https://cdn.faire.com/fastly/0a95e6f48c76beefb3dfab743f689679947a5fa44e6861bc6cf6087854858a4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fbe654374c075be4c5a6e98dd8b94204b4c034b11ec181fa351b2edd774c883.jpeg",
  ],
  priceDollars: 19.2,
  description:
    "OLAPLEX No. 5 Bond Maintenance Conditioner is a highly nourishing formula designed to repair dry and damaged hair, by hydrating and restoring its natural strength. This sulfate-free conditioner helps to repair and protect hair from daily damage, restoring moisture and improving texture. It works by rebuilding the broken disulfide bonds in the hair, leaving it visibly smoother, healthier, and more manageable. Ideal for all hair types, it also helps to reduce frizz and enhance shine, making your hair feel soft, strong, and revitalized. Use it regularly for long-lasting results and a salon-quality finish.\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:37.122Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
